<template>
    <div class="comment__new-comment">
        <vue-editor
        v-model="newCommentModel.comment"
        :editor-toolbar="customToolbar"
        :editorOptions="editorSettings"
        :id="`newComment--${commentId}`"
        /> 
        <div class="comment__new-comment__files">
            <div class="file-name" v-for="(att, attIdx) in newCommentModel.attach" :key="attIdx">
             <span>{{att.originalFileName}}</span> 
            <i class="material-icons" @click.stop="newCommentModel.attach.splice(attIdx,1)">close</i> 
            </div>
        </div>
        <div class="comment__new-comment__actions">
            <div class="upload-file">
                <div @change="uploadFile($event)" class="upload-file__container">
                    <input type="file" accept=".doc,.docx,.ppt,.pptm,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.xls,.xlsx" name="attach" :id="`${commentId ? commentId : content.id }-attach`">
                    <label :for="`${commentId ? commentId : content.id }-attach`">{{$t('file.UPLOAD_FILE')}}<i class="material-icons">file_upload</i></label>
                </div>
                <button @click.stop="showPopUp = !showPopUp" @mouseover="!isMobile && setPopUpHover(true)" @mouseleave="!isMobile && setPopUpHover(false)"  >
                    <i class="material-icons-outlined">info</i>
                </button>
                <HoverPopUp v-if="showPopUp" :content="$t('file.MAX_FILE_WEIGHT')" />
            </div>
            
            <div>
            <button class="btn-discard" @click.stop="discard" >{{$t('global.DISCARD')}}</button>
            <button class="btn-comment" @click.stop="post" >{{$t('global.COMMENT')}}</button>
            </div>
        </div>
    </div>

    <Modal v-if="fileUploading" :isOpen="fileUploading" :closeButton="false">
        <div class="modal__content">
            <i class="material-icons-outlined modal__icon">cloud_upload</i>
            <h4 class="modal__title">{{ $t('file.uploading.TITLE') }}</h4>
            <p class="modal__message">{{ $t('file.uploading.MESSAGE') }}</p>
            <div class="modal__bar"></div>
        </div>
    </Modal>

    <Modal v-if="uploadErrorModal" :isOpen="uploadErrorModal" @close="uploadErrorModal = false">
        <div class="modal__content">
            <i class="material-icons-outlined modal__error--icon">cancel</i>
            <h4 class="modal__error--title">{{$t('file.uploading_error.TITLE')}}</h4>
            <p class="modal__error--message">{{$t('file.uploading_error.MESSAGE')}}</p>
            <div class="upload-file">
                <div @change="uploadFile($event)" class="upload-file__container">
                    <input type="file" accept=".doc,.docx,.ppt,.pptm,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.xls,.xlsx" name="attach" :id="`${commentId ? commentId : content.id }-attach`">
                    <label :for="`${commentId ? commentId : content.id }-attach`">{{$t('file.UPLOAD_FILE')}}<i class="material-icons">file_upload</i></label>
                </div>
            </div>
        </div>
    </Modal>
</template>

<script>
import { VueEditor, Quill } from "vue3-editor";
import Emoji from "quill-emoji/dist/quill-emoji";
import storage from "@/plugins/azure-storage";
Quill.register("modules/emoji", Emoji);
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import HoverPopUp from "../HoverPopUp.vue";
// import Loader from '../Loader.vue'
import Modal from "../Modal.vue";
import { useI18n } from 'vue-i18n';


    export default {
        components:{
    VueEditor,
    HoverPopUp,
    // Loader,
    Modal
},
        props: ['commentId', 'content', 'index', 'view'],
        emits: ['postComment', 'discardComment'],
        setup(props, { emit }) {
            const newCommentModel = ref( {
                comment: props.content === undefined ? '' : props.content.comment,
                attach: props.content === undefined ? [] : props.content.attach,
                replies: [],
                relatedCommentId: props.commentId === 'newComment' ? null : props.commentId
            });
            const fileUploading = ref()
            const commentActivate = ref(false)
            const store = useStore();
            const showPopUp = ref(false)
            const isMobile = ref(window.innerWidth < 870)
            const uploadErrorModal = ref(false)
            const { t } = useI18n();

            

            async function uploadFile(event) {
                let fileAccepted = ['application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/vnd.ms-powerpoint','application/vnd.ms-powerpoint.presentation.macroEnabled.12','application/vnd.openxmlformats-officedocument.presentationml.presentation','application/pdf','image/png','image/jpeg','image/gif','application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
                let fileIsOk = false
                let file = event.target.files[0];
                if(!file) return false;
                for (const ext of fileAccepted){
                    if(ext === file.type) fileIsOk = true  // Si el tipo de arcivo es correcto, entonces permitira que se suba el archivo. (fileIsOk set in true)
                }
                if (file.size > 629145600 || fileIsOk === false) {
                    uploadErrorModal.value = true
                    return false;
                }
                fileUploading.value = true
                try {
                    uploadErrorModal.value = false
                    let fileCDN = await storage.updateFile(file,'foroComment');
                    newCommentModel.value.attach.push({file: fileCDN, originalFileName: file.name, contentType: file.type});
                    fileUploading.value = false;
                } catch (error) {
                    console.log(error);
                    uploadErrorModal.value = true
                    fileUploading.value = false
                }
            }

            function cleanNewCommentModel() {
                newCommentModel.value = {
                    comment: '',
                    attach: [],
                    replies: [],
                    relatedCommentId: null
                }
            }           
            
            const post = () => {
                let text = document.getElementById(`newComment--${props.commentId}`).innerText.trim()
                if(text.length === 0 && newCommentModel.value.attach.length === 0){
                    store.dispatch("notifications_create", {text: t('comments.ERROR_EMPTY_COMMENT')});
                    return
                }
                if(props.content !== undefined){
                    let editComment = {
                        id: props.content.id,
                        comment: newCommentModel.value.comment,
                        attach: newCommentModel.value.attach
                    }
                    props.view === 'board' && emit('postComment', editComment, props.index)
                }
                else{
                    newCommentModel.value.comment
                    props.view === 'board' && emit('postComment', newCommentModel.value),
                    cleanNewCommentModel()
                }
                emit('discardComment', props.index)
            }

            const discard = () => {
                emit('discardComment', props.index)
            }

            const setPopUpHover = (value) => {
                showPopUp.value = value
            }

            onMounted(() => {
                isMobile.value = window.innerWidth < 1000
                window.addEventListener('resize', () => isMobile.value = window.innerWidth < 1000 )
            })

            return {
                newCommentModel,
                commentActivate,
                post,
                uploadFile,
                discard,
                setPopUpHover,
                showPopUp,
                isMobile,
                uploadErrorModal,
                fileUploading,
                customToolbar: [
                ["bold", "italic", "underline", "strike"],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }, { color: [] }, { background: [] },],
                ["emoji"]
                ],
                editorSettings: {
                    modules: {
                    "emoji-toolbar": true,
                    "emoji-textarea": false,
                    "emoji-shortname": false,
                    },
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';
.hover__container{
    position: absolute;
    left: 172px;
    bottom: 25px;
    @media screen and (max-width: 860px){
        position: absolute;
        left: 37%;
        bottom: 118px;
        width: 200px;
    }
}

.modal{
    &__content{
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        flex-direction: column;
        padding: 16px;
        width: 691px;
        .modal__icon{
            color: #fff;
            font-size: 26px;
            padding: 16px;
            background: linear-gradient(180deg, #54C5C5 17.71%, #009696 100%);
            border-radius: 999px;
            margin-bottom: 12px;
        }
    }
    &__title{
        font-size: 18px;
        margin-bottom: 6px;
    }
    &__message{
        font-size: 14px;
        font-weight: 400;
    }
    &__bar{
        margin-top: 14px;
        margin-left: 25%;
        margin-right: 25%;
        width: 0%;
        height: 4px;
        background  : linear-gradient(270deg, #009696 0%, #DDDDDD 100%);
        border-radius: 999px;
        align-self: flex-start;
        animation: uploading 3s infinite ease-in;
        @keyframes uploading{
            0%{
                width: 0%;
            }
            50%{
                width: 50%;
            }
            100%{
                width: 0%;
            }
        }
    }
    &__error{
        &--icon{
            color: $red;
            font-size: 36px;
            margin-bottom: 12px;
        }
        &--title{
            font-size: 18px;
            margin-bottom: 6px;
        }
        &--message{
            font-size: 14px;
            font-weight: 400;
            width: 100%;
            margin-bottom: 24px;
        }
    }
}

.hover__content{
    @media screen and (max-width: 860px){
        font-size:12px;
    }
}
.comment{
    &__new-comment {
        @include flex-column;
        gap: 8px;
        width: 100%;
        margin-top: 12px;
        .quillWrapper {
        width: 100%;
        }
        &--uploadingAttach{
            @media screen and (min-width: 1000px){
                margin-left: 24px;
            }
        }
        &__files{
        width: 100%;
        margin-bottom: 8px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: 4px;
        .file-name{
            padding: 4px 16px;
            padding-right: 8px;
            display: inline-flex;
            align-items: center;
            gap: 4px;
            border: 1px solid #ccc;
            background: #f5f5f5;
            border-radius: 44px;
            color: $black;
            font-size: 13px;
            line-height: 16px;
            font-weight: 600;
            .material-icons{
            color: #333;
            font-size: 16px;
            line-height: 16px;
            cursor: pointer;
            }
        }      
        }
        &__actions{
        position: relative;
        width: 100%;
        height: fit-content;
        display: flex;
        justify-content: space-between;
        @media screen and (max-width: 1000px){
            flex-direction: column;
            align-items: center;
            gap: 16px;
        }
        .material-icons-outlined{
            color: $green;
        }
        .upload-file{
            display: flex;
            align-items: center;
            gap: 6px;
            &__container{
                @media screen and (max-width: 1000px){
                align-self: flex-start;
                }   
                input{
                    visibility: hidden;
                    position: absolute;
                    width: 0px;
                    height: 0px;
                    top: 0;
                    left: 0;
                }
                label{
                    padding: 4px 16px;
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                    border: 1px solid $green;
                    border-radius: 44px;
                    color: $green;
                    font-size: 13px;
                    font-weight: 600;
                    cursor: pointer;
                    .material-icons{
                        color: $green;
                        font-size: 22px;
                    }
                }
            }
        }
        >div:last-child{
            display: inline-flex;
            gap: 16px;
            @media screen and (max-width: 1000px){
                flex-direction: column-reverse;
                width: 100%;
                gap: 0;
            }
            button{
            height: 32px;
            padding: 0 16px;
            border-radius: 44px;
            font-weight: 600;
            font-size: 13px;
            line-height: 16px;
            }
            .btn-comment {
            background-color: $green;
            color: #fff;
            }
            .btn-discard{
            color: $green;
            }
        }
        }
    }
}

.quillWrapper .ql-snow.ql-toolbar{
    @media screen and (max-width: 1000px){
        padding: 0;
    }
}

.disabled{
    opacity: .2;
    cursor: default;
}

</style>